import { Button, ButtonVariation } from "components/Button/Button";
import { ReactNode } from "react";
import "./BufferedDialogButtons.scss";

export interface BufferedDialogButtonsProps {
    /** Discard local edits and (in a dialog) dismiss. */
    onCancel: () => void;
    /** Persist the buffered draft. */
    onSave: () => void;
    /** Whether the draft differs from the last-saved baseline (gates Save). */
    isDirty: boolean;
    /** A save is in flight (spins the Save button and disables both). */
    isSaving?: boolean;
    cancelLabel?: string;
    saveLabel?: string;
    saveVariation?: ButtonVariation;
    /** Optional extra control rendered left of Cancel. */
    additionalActionButton?: ReactNode;
}

/**
 * Canonical footer for a buffered dialog form: a neutral Cancel/Close on the
 * left and a single dominant Save on the right — following
 * ui-design-principle-buttons (one primary/blue dominant action, a white
 * neutral peer) and the established dialog footer convention. Save is disabled
 * until the draft is dirty and shows a loading spinner while saving.
 */
export const BufferedDialogButtons = ({
    onCancel,
    onSave,
    isDirty,
    isSaving = false,
    cancelLabel = "Cancel",
    saveLabel = "Save",
    saveVariation = "primary",
    additionalActionButton,
}: BufferedDialogButtonsProps) => (
    <div className="bufferedDialogButtons">
        {additionalActionButton}
        <Button
            label={cancelLabel}
            variation="white"
            disabled={isSaving}
            onClick={onCancel}
        />
        <Button
            label={saveLabel}
            variation={saveVariation}
            loading={isSaving}
            disabled={!isDirty || isSaving}
            onClick={onSave}
        />
    </div>
);

export default BufferedDialogButtons;
